import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { postBPDataWithoutParams } from 'src/business/services'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { ClinicLocationOnboardingComponent } from '../onboardng/ClinicOnboardingComponents'

export default function ClinicLocationProfile() {
  const { clinicId, clinicBrandId } = useParams()
  const { ownerData, refreshOwnerAssociatedClinicsData } = useContext(ClinicDataContext)
  const [clinicLocationData, setClinicLocationData] = useState()
  const [loading, setLoading] = useState()

  const thisClinicData = {
    ...ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId),
    apiParam: 'clinic-profile',
  }

  const thisClinicBrandData = ownerData?.associatedClinicBrandsData?.find(
    (item) => item?.id === clinicBrandId,
  )

  async function saveClinicLocationDetails() {
    setLoading(true)
    const responseSaveProfile = await postBPDataWithoutParams('/api/secure/cp/clinic/save', {
      ...clinicLocationData,
      slug: clinicLocationData?.slug || clinicLocationData?.tempSlug,
    })
    setLoading(false)
    if (
      responseSaveProfile?.status === 200 &&
      isCommonResponseSuccessful(responseSaveProfile?.data?.code) &&
      responseSaveProfile?.data?.data?.clinic
    ) {
      await refreshOwnerAssociatedClinicsData()
      toast.success('Details updated successfully')
    } else {
      toast.error('Error updating details')
    }
  }

  useEffect(() => {
    const row = ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)
    if (row?.id) {
      setClinicLocationData({ ...row, apiParam: 'clinic-profile' })
    }
  }, [clinicId, clinicBrandId, ownerData?.associatedClinicsData])

  return (
    <>
      <ClinicHeader
        heading={`${thisClinicData?.name || thisClinicData?.title} | Location Settings`}
      />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <ClinicLocationOnboardingComponent
        clinicLocationData={clinicLocationData}
        setClinicLocationData={setClinicLocationData}
        clinicParentBrandData={thisClinicBrandData}
        customHeading="Edit Clinic Location Details"
        saveClinicLocation={saveClinicLocationDetails}
        savingClinicLocation={loading}
      />
      {/* <ProfileDataComponent
        allLegalPolicies={[]}
        profileData={thisClinicData}
        enteringFirstTime={false}
        updateProfileData={refreshOwnerAssociatedClinicsData}
        setDontShowKycModal={() => {}}
        saveApiToUse="/api/secure/cp/clinic/save"
        tabLabelAndComponentChanger={{
          [mentorProfileAllPages?.mentoring?.pageValue]: {
            label: 'Clinic Staff',
            component: ClinicStaffTabComponent,
          },
        }}
      /> */}
    </>
  )
}
